/**
 * @fileoverview Agent definition for pov-changer-v2.
 *
 * This agent rewrites a chapter draft with a new point of view (POV type and/or narrator).
 * For minor changes (same narrator, different person), it preserves as much of the
 * original writing as possible. For larger changes (different narrator), it performs
 * a more substantial rewrite.
 *
 * @category narrative.prose.revision
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'pov-changer-v2',
  kind: 'primitive',
  name: 'POV Changer',
  description: 'Rewrites a chapter draft with a new point of view (type and/or narrator).',
  category: 'writing',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  // --- Metadata (Hybrid Architecture) ---
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-01',
    lastUpdated: '2026-01',
    taxonomyPath: 'narrative.prose.revision',
    usedBy: [
      'use-pov-changer-v2.ts',
      'use-ai-control-panel.ts',
    ],
    usedInComposites: [],
    relatedAgents: [
      'draft-refiner-v2',
      'pov-suggester-v2',
    ],
  },
};
